import "./Resources.module.css";
import Header from "@/reusable_sections/Header";
import FinancialIntelligence from "./sections/FinancialIntelligence";
import StayInformed from "./sections/StayInformed";
import Footer from "@/reusable_sections/Footer";
export default function ResourcesPage() {
  return <div>
      <Header />
      <FinancialIntelligence />
      <StayInformed />
      <Footer />
    </div>;
}